module.exports = __webpack_public_path__ + "static/media/SettingsSelected.eae5709a.svg";